module.exports = __webpack_public_path__ + "static/media/IMG_1230.6e3c46e9.jpg";